import React, { memo } from 'react';
import { CircularProgress, Button as MuiButton } from '@mui/material';

import { ReactComponent as ArrowRight } from '../../../../assets/icons/ArrowRight.svg';

import { useStyles } from './styles';

export interface IButtonProps {
  label: React.ReactNode;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  hasEndArrow?: boolean;
  hasStartArrow?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  disableRipple?: boolean;
  styleClass?: string;
  testId?: string;
  onClick?: () => void;
}

const Button = ({
  label,
  variant = 'contained',
  color = 'primary',
  hasStartArrow,
  hasEndArrow,
  startIcon,
  endIcon,
  disabled,
  isLoading,
  disableRipple,
  styleClass,
  testId,
  onClick,
}: IButtonProps) => {
  const classes = useStyles();
  return (
    <MuiButton
      variant={variant}
      className={`${classes[`${color}-${variant}`]} ${styleClass || ''}`}
      color={color}
      data-testid={testId}
      startIcon={
        isLoading ? (
          <CircularProgress className={classes.spinner} />
        ) : hasStartArrow ? (
          <ArrowRight className={classes.arrowLeft} />
        ) : (
          startIcon
        )
      }
      endIcon={hasEndArrow ? <ArrowRight /> : endIcon}
      disabled={disabled || isLoading}
      disableRipple={disableRipple}
      onClick={onClick}
    >
      {label}
    </MuiButton>
  );
};

export default memo(Button);
